// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForCenterItems = makeThemedStyles('CenterItems', () => ({
  CenterItems: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const CenterItems: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForCenterItems();

  /* eslint-disable */
  return (
    <div {...props} style={{ ...(props?.style || {}), ...{} }} className={clsx(styles.CenterItems)}>
      {props?.children}
    </div>
  );
};
export default CenterItems;
